import { createApp } from 'vue'
import '@styles/bootstrap.scss'
import '@styles/styles.scss'
import App from './App.vue'


import Galleria from 'primevue/galleria';

import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";

import { getFawLibrary } from '@ts/func.common';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeLayers,FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';//
library.add(...getFawLibrary());

const app = createApp(App);
app.use(PrimeVue, {
    theme: {preset:Aura}
});
app.component('Galleria', Galleria);
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('font-awesome-layers', FontAwesomeLayers);
app.component('font-awesome-layers-text', FontAwesomeLayersText);


app.mount('#app');

